import React from 'react'
import Layout from './src/components/templates/Layout'
import './src/style/style.css'

export const wrapPageElement = ({ element, props }) => {
    return <Layout {...props}>{element}</Layout>
  }

export const onRouteUpdate = ({ location }) => {
  const noWidgetPaths = ['/meer-informatie', '/meer-informatie/']
  if (noWidgetPaths.includes(location.pathname)) {
    document.body.classList.add('hide-reservation-widget')
  } else {
    document.body.classList.remove('hide-reservation-widget')
  }
}
